<template>
    <div class="cell-content is-full is-flex">
        <template v-if="!hasAddress">-</template>
        <template v-else>{{ address.country }}</template>
    </div>
</template>

<script>
import Cell from './cell';

export default {
    mixins: [ Cell ],

    props: {
        value: {
            type: [Array]
        }
    },

    computed: {
        address() {
            return this.row.addresses && this.row.addresses.length > 0 ? this.row.addresses[0] : null
        },

        hasAddress() {
            return !!this.address
        },
    },
}
</script>
